<div class="subheader" [ngClass]="{'mobile': mobile}">
  <div class="subheader-left-part">
    <div class="select-outlets">
      <i *ngIf="mobile" class="icon icon-shop" (click)="isShowChangeOutlet = true"></i>
      <app-change-outlet
        *ngIf="!mobile || isShowChangeOutlet"
        [mobile]="mobile"
        [isLoginSuperBusinessAdminOrBusinessAdmin]=" isLoginSuperBusinessAdminOrBusinessAdmin"
        (closeAction)="isShowChangeOutlet = false"
      ></app-change-outlet>
    </div>
    <ng-container *ngIf="!mobile && isLoginSuperBusinessAdminOrBusinessAdmin">
      <div class="divider p-l-12"></div>
      <div class="wrap-modal-window" appOutsideClick (outsideClick)="outsideClick()" [ngClass]="{'open': IsOpenModal}">
        <i class="icon icon-admin-panel"></i>
        <div class="user-name"
             (click)="toggleOpenModal()"
        >{{ userLogin }}
        </div>
        <div class="modal-window-change-user" *ngIf="IsOpenModal" >
          <app-change-user-form [title]="'loginAsOutlet' | translate"></app-change-user-form>
        </div>
      </div>
    </ng-container>
  </div>

  <div class="subheader-right-part">
    <div *ngIf="this.isShowCreditLimit()"
         class="credit-limit"
         id="creditLimitId"
         (click)="goToDebt()"
          (mouseenter)="showTooltip()"
          (mouseleave)="showTooltip(false)">
         <i class="icon-cash icon-debt"></i>
        <span class="cart-price" [innerHTML]="creditLimit | number: '1.2-2' : 'en'"></span>
        <app-tooltip
          *ngIf="this.isTooltipVisible"
          class="credit-limit-tooltip_popover"
          [settings]=" {
                  innerText: ( 'free-credit-limit' | translate ),
                  position: 'bottom',
                  positionOffset: 0,
                  positionArrowOffset: 0,
                  isCloseButton: false,
                  refIdElement: 'creditLimitId',
                  idElementScroll: null
                }"
          (click)="$event.stopPropagation(); $event.preventDefault()"
        ></app-tooltip>
      </div>
      <div class="debt-btn" *ngIf="isShowDebt() && !isShowCreditLimit()" (click)="goToDebt()">
        <i class="icon-cash icon-debt"></i>
        <span *ngIf="!mobile" class="debt-btn-text">{{'debt-btn-header' | translate}}</span>
      </div>
<!--      <div class="task divider">-->
<!--        <i class="icon icon-task-coin"></i>-->
<!--        <span>{{'140' | number: '1.2-2' : 'en'}}</span>-->
<!--      </div>-->
      <div class="weather divider" *ngIf="!!showModuleForSubheader()">
        <div  [loadModule]="showModuleForSubheader()"></div>
      </div>
  </div>
</div>
